<div class="h-100 filter-background" *ngIf="!filterHidden$.value">
  <span class="title d-flex - justify-content-between">{{'filter'|translate}}
    <mat-icon class="main-blue cursor-pointer" (click)="hideFilter()">close</mat-icon></span>

  <ng-scrollbar visibility="hover" class="scrollbar">
    <button class="blue-border reset-filter-button" (click)="resetFilter()"><img alt="" class="me-2"
                                                                                 src="assets/svg-icons/reset.svg">{{'resetFilter'|translate}}
    </button>
    <div class="d-flex flex-column filter-bar">

      <div class="filter-group" [formGroup]="formGroup">
        <mat-radio-group formControlName='selectedRole' (change)="updateSelectedFilter($event)">
          <mat-radio-button
            [value]="FilterRole.ALL"
            matTooltip="{{'applicationType.all.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.all.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.all }})</span>
          </mat-radio-button>
          <mat-radio-button *ngIf="(roles$|async).includes(Roles.ROLE_UNDERWRITER) || (roles$|async).includes(Roles.ROLE_INSURER)"
                            [value]="FilterRole.MY_PROPOSALS"
                            matTooltip="{{'applicationType.myProposals.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.myProposals.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.myProposals }})</span>
          </mat-radio-button>
          <mat-radio-button *ngIf="(roles$|async).includes(Roles.ROLE_BROKER) || (roles$|async).includes(Roles.ROLE_UNDERWRITER) || (roles$|async).includes(Roles.ROLE_INSURER)"
                            [value]="FilterRole.SUBSTITUTES"
                            matTooltip="{{'applicationType.onlySubstitutes.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.onlySubstitutes.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.onlySubstitutes }})</span>
          </mat-radio-button>
          <mat-radio-button
            [value]="FilterRole.PRIVATE"
            matTooltip="{{'applicationType.private.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">
            {{'applicationType.private.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.privates }})</span>
          </mat-radio-button>

          <mat-radio-button *ngIf="(roles$|async).includes(Roles.ROLE_BROKER) || (roles$|async).includes(Roles.ROLE_UNDERWRITER) || (roles$|async).includes(Roles.ROLE_INSURER)"
                            [value]="FilterRole.HAS_OFFERS"
                            matTooltip="{{'applicationType.offerReceived.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.offerReceived.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.hasOffers }})</span>
          </mat-radio-button>
          <mat-radio-button *ngIf="(roles$|async).includes(Roles.ROLE_UNDERWRITER) || (roles$|async).includes(Roles.ROLE_INSURER)"
                            [value]="FilterRole.OFFER_SUBMITTED"
                            matTooltip="{{'applicationType.offerSubmitted.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.offerSubmitted.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.offerSubmitted }})</span>
          </mat-radio-button>

          <mat-radio-button
            [value]="FilterRole.RETRACTED_PROPOSALS"
            matTooltip="{{'applicationType.retractedProposals.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.retractedProposals.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.retractedProposals }})</span>
          </mat-radio-button>
          <mat-radio-button *ngIf="(roles$|async).includes(Roles.ROLE_UNDERWRITER) || (roles$|async).includes(Roles.ROLE_INSURER)"
                            [value]="FilterRole.RETRACTED_OFFERS"
                            matTooltip="{{'applicationType.retractedOffers.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.retractedOffers.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.retractedOffers }})</span>
          </mat-radio-button>

          <mat-radio-button
            [value]="FilterRole.REJECTED_PROPOSALS"
            matTooltip="{{'applicationType.rejected.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'"> {{'applicationType.rejected.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.rejectedProposals }})</span>

          </mat-radio-button>

          <mat-radio-button *ngIf="(roles$|async).includes(Roles.ROLE_BROKER) || (roles$|async).includes(Roles.ROLE_UNDERWRITER) || (roles$|async).includes(Roles.ROLE_INSURER)"
                            [value]="FilterRole.EXPIRED"
                            matTooltip="{{'applicationType.expired.tooltip' | translate}}" [matTooltipShowDelay]="300" [matTooltipPosition]="'right'">{{'applicationType.expired.label'|translate}} <span *ngIf="tilesNumber !== null">({{ tilesNumber.expired }})</span>
          </mat-radio-button>
        </mat-radio-group>

      </div>

      <div class="filter-group" [formGroup]="formGroup">
        <span class="filter-subtitle mt-4">{{'details'|translate}}</span>
        <mat-checkbox
          formControlName="noCoverage">{{'applicationType.noCoverage'|translate}}</mat-checkbox>
        <mat-checkbox
          formControlName="leadInsurerNeeded">{{'applicationType.leadInsurer'|translate}}</mat-checkbox>
        <mat-checkbox
          formControlName="followingInsurerNeeded">{{'applicationType.followingInsurer'|translate}} </mat-checkbox>
        <div class="d-flex ">
          <mat-checkbox
            formControlName="limitPrice" class="limitPrice">
          </mat-checkbox>
          <input appNumberFormat
                 [placeholder]="('From'|translate) + ' €'"
                 formControlName="minimumAmountInsured">
          <input appNumberFormat [placeholder]="('To'|translate) + ' €'"
                 formControlName="maximumAmountInsured">
        </div>
      </div>

      <div *ngIf="(lineOfBusinessForm.controls|keyvalue).length >0" [formGroup]="lineOfBusinessForm"
           class="filter-group">
        <span class="filter-subtitle mt-4">{{'lineOfBusiness.name'|translate}}</span>
        <ng-container class="d-flex" *ngFor="let lob of lineOfBusinessForm.controls | keyvalue; let i = index">
          <mat-checkbox *ngIf="i<numberOfLinesOfBusinessShow"
                        [formControlName]="lob.key">
            <span class="lobNumber">{{lob.key}}{{ " - " }}</span><span
            class="d-flex line-of-business-text">{{'lineOfBusiness.clauses.' + lob.key + '.name' | translate}}</span>
          </mat-checkbox>
        </ng-container>
        <div *ngIf="(lineOfBusinessForm.controls|keyvalue).length >= numberOfLinesOfBusinessShowDefault"
             class="show-more-button blue-border"
             (click)="calculateNumberOfLinesOfBusinessShown()">
          <div *ngIf="!showMoreFilters">
            {{'showMore' | translate}}
          </div>
          <div *ngIf="showMoreFilters">
            {{'showLess' | translate}}
          </div>
        </div>
      </div>

    </div>
  </ng-scrollbar>
</div>
